import React from "react";
import { LegalLayout, H2, H3, P, UL, LI } from "@/components/LegalLayout";

export default function Support() {
  return (
    <LegalLayout
      title="Support"
      updated="June 1, 2026"
      intro="We're here to help you get the most out of Next Time. Find quick answers below, or reach out any time."
    >
      <div className="rounded-2xl bg-cardbg border border-cardborder p-6 mb-8">
        <p className="font-serif text-xl text-ink">Contact us</p>
        <p className="mt-2 text-ink-muted leading-relaxed">Email us at <a href="mailto:decompresspause@gmail.com" className="font-semibold text-sage-hover underline">decompresspause@gmail.com</a>. We aim to reply within 1–2 business days.</p>
      </div>

      <H2>Getting started</H2>
      <H3>How do I begin?</H3>
      <P>Tap “Try It” to jump straight into a role-play, or “Get started” to enter the app. No account or email is required to start, you can begin as a guest.</P>
      <H3>Do I have to create an account?</H3>
      <P>No. You can use Next Time as a guest. Creating an account simply lets you keep your history and progress across devices.</P>

      <H2>Using the app</H2>
      <H3>How does the AI role-play work?</H3>
      <P>Pick a situation and difficulty. The AI plays a realistic counterpart that pushes back, then steps out of character at the end to give you specific, non-judgmental feedback and a line to practice.</P>
      <H3>What is a “moment”?</H3>
      <P>A moment is something that didn’t go the way you wanted. Capture it while it’s fresh and Next Time helps separate the facts from the story, points out what was in your control, and suggests a stronger response you can rehearse.</P>
      <H3>What are patterns and playbooks?</H3>
      <P>Patterns are recurring themes that surface gently over time as you reflect and practice. Playbooks are your best responses saved as go-to strategies for next time.</P>

      <H2>Account and data</H2>
      <H3>How do I export or delete my data?</H3>
      <P>Open Settings to export all of your data as a file, or to delete individual moments and clear your content. See our <a href="/privacy" className="underline hover:text-ink">Privacy Policy</a> for details.</P>
      <H3>How do I manage my subscription?</H3>
      <P>Next Time Pro is billed through the Apple App Store or Google Play. Manage or cancel auto-renewal in your store account settings. See the <a href="/subscription-terms" className="underline hover:text-ink">Subscription Terms</a>.</P>

      <H2>Important safety note</H2>
      <P>Next Time is a practice and reflection tool, not therapy or a crisis service. If you are in distress or in an emergency, please contact your local emergency services or a crisis line in your country right away. In the U.S., you can call or text <strong>988</strong> for the Suicide & Crisis Lifeline.</P>

      <H2>Still need help?</H2>
      <UL>
        <LI>Email <a href="mailto:decompresspause@gmail.com" className="underline hover:text-ink">decompresspause@gmail.com</a> with a description of the issue.</LI>
        <LI>Include your device and app version if it’s a technical problem.</LI>
        <LI>For billing issues with a store purchase, you may also need to contact Apple or Google directly.</LI>
      </UL>
    </LegalLayout>
  );
}
